import { ApiRequestStore } from '../../../common/apiRequest.store'

class PerformanceCreateStore extends ApiRequestStore {}

export const performanceCreateStore: PerformanceCreateStore = new PerformanceCreateStore()
